module.exports = __webpack_public_path__ + "img/model_100.56bb32ea.jpg";